/**
 * @module events/types/scroll
 */

/**
 * @type {string}
 */
export default 'scroll'
